// pages/orders/OrderForm.jsx
import { useEffect, useState } from "react";
import { ordersAPI, customersAPI, settingsAPI } from "../../services/api";
import { useRouter }  from "../../contexts/RouterContext";
import { useToast }   from "../../contexts/ToastContext";
import { Breadcrumb, Loading, Spinner } from "../../components/ui";
import { fmt }        from "../../utils/helpers";

export default function OrderForm({ preCustomerId }) {
  const { navigate , back } = useRouter();
  const toast        = useToast();
  

  const [customers, setCustomers] = useState([]);
  const [settings,  setSettings]  = useState(null);
  const [loading,   setLoading]   = useState(false);
  const [fetching,  setFetching]  = useState(true);
  const [errors,    setErrors]    = useState({});

  const [form, setForm] = useState({
    customerId:   preCustomerId || "",
    orderDate:    new Date().toISOString().split("T")[0],
    deliveryDate: "",
    amount:       "",
  });

  // ✅ FIXED useEffect (NO MORE INFINITE LOADING)
  useEffect(() => {
    const init = async () => {
      try {
        console.log("Loading data...");

        const custList = await customersAPI.list();
        // const s        = await settingsAPI.get();

        console.log("Customers:", custList);
        // console.log("Settings:", s);

        setCustomers(custList);
        // setSettings(s);

        const cid = preCustomerId || (custList[0]?.id ?? "");

        setForm((f) => ({
          ...f,
          customerId: cid,
        }));

      } catch (e) {
        console.error("INIT ERROR:", e);
       toast("Failed to load data", "error");
      } finally {
        setFetching(false); // ✅ IMPORTANT
      }
    };

    init();
  }, []);

  const setF = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e.target.value }));
    if (errors[key]) setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  // ✅ CREATE ORDER ONLY (CORRECT FLOW)
  const handleCreateOrder = async () => {
    const e = {};

    if (!form.customerId)   e.customerId = "Select customer";
    if (!form.deliveryDate) e.deliveryDate = "Select delivery date";

    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    setLoading(true);

    try {
      console.log("Creating order...");

      const res = await ordersAPI.create({
        customerId: parseInt(form.customerId),
        amount: 0,
        discount: 0,
        remarks: "",
        orderdate: form.orderDate,
        deliveryDate : form.deliveryDate
      });

      console.log("CREATE RESPONSE:", res);

      const orderId =
      res?.OM_ID ||
      res?.data?.OM_ID  ||
      res?.OM_ID  ||
      null;

      if (!orderId) throw new Error("Order ID missing");

      toast("Invoice generated ✅");

      // 🚀 REDIRECT TO ORDER DETAIL
      navigate("order-detail", { id: orderId , mode : "edit" });

    } catch (err) {
      console.error("CREATE ERROR:", err);
      toast("Failed to create order" , "error");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="page">
        <Loading />
      </div>
    );
  }

  return (
    <div className="page">

      <Breadcrumb items={[
        { label: "Orders", onClick: () => navigate("orders") },
        { label: "Create Order" },
      ]} />

      

      <div style={{ display: "flex", alignItems: "center", gap: 50 }}>
  
        {/* 🔙 BACK BUTTON */}
        <button
          className="btn btn-ghost"
          onClick={back}
        >
          ←
        </button>

        {/* TITLE */}
        <div>
          <h1 className="page-title">Generate Invoice</h1>
          <p className="page-sub">Create order first, then add items</p>
        </div>

      </div>

      <div className="card">
        <div className="form-grid">
          <div className="form-group form-full">
            <label className="form-label">
              Customer <span className="form-required">*</span>
            </label>
            <select
              className={`form-select${errors.customerId ? " error" : ""}`}
              value={form.customerId}
              onChange={setF("customerId")}
            >
              <option value="">— Select Customer —</option>
              {customers.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name} · {c.phone}
                </option>
              ))}
            </select>
            {errors.customerId && (
              <span className="form-error">{errors.customerId}</span>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">Order Date</label>
            <input
              className="form-input"
              type="date"
              value={form.orderDate}
              onChange={setF("orderDate")}
            />
          </div>
          <div className="form-group">
            <label className="form-label">
              Delivery Date <span className="form-required">*</span>
            </label>
            <input
              className={`form-input${errors.deliveryDate ? " error" : ""}`}
              type="date"
              value={form.deliveryDate}
              onChange={setF("deliveryDate")}
              min={form.orderDate}
            />
            {errors.deliveryDate && (
              <span className="form-error">{errors.deliveryDate}</span>
            )}
          </div>
        </div>
        <div style={{ marginTop: 20 }}>
          <button
            className="btn btn-primary btn-lg"
            onClick={handleCreateOrder}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner /> Creating...
              </>
            ) : (
              "🧾 Generate Invoice"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}